import React from 'react';
import { FormatUtil } from "@graffer-inc/graffer-ui";
import Transition from '../../../utils/transition';
import EntryStatus from '../../atoms/entry-status';
import APPLICATION_TYPE from '../../../constants/application-type';

const Main = ({entry}) => (
  <div className="cm__entry-list-item">
    <div>
      <div className="columns">
        <div className="column is-narrow">
          <div style={{padding: '12px 0 0 0'}}>
            <EntryStatus status={entry.status} isRefunded={entry.isRefunded} />
          </div>
        </div>
        <div className="column">
          <p className="has-text-centered">
            <span className="is-size-6">
              {APPLICATION_TYPE.name(entry.applicationType)}プラン
            </span>
                <span className="is-size-6" style={{padding: '0 5px'}}>
              /
            </span>
                <span className="is-size-6">
              証明期間
            </span>
                <span className="is-size-3 is-size-4-mobile has-text-weight-bold" style={{padding: '0 5px'}}>
              {entry.certPeriod}
            </span>
                <span className="is-size-6">
              ヵ月
            </span>
          </p>
        </div>
        <div className="column is-narrow has-text-right">
          <div style={{padding: '12px 0 0 0'}}>
            <button
              className="button is-rounded is-size-7-mobile"
              onClick={() => Transition.goTo(`/entries/${entry.id}`)}
            >
              詳細を見る
            </button>
          </div>
        </div>
      </div>
      <p className="has-text-right is-size-7 has-text-grey">
        申込日時: {FormatUtil.dateWithTime(entry.createdAt)}
      </p>
    </div>
  </div>
);

export default Main;